import React from "react";

import cn from "classnames";

import styles from "./styles.module.scss";

export interface InscriptionProps {
  title?: string;
  className?: string;
}

export const Inscription: React.FC<InscriptionProps> = (props) => {
  const { title, className } = props;
  return (
    <div className={cn([styles.wrapper, className])}>
      <div className={styles.title}>{title}</div>
      {props.children}
    </div>
  );
};
